<template>
  <div class="settings">
    <VPBreadcrumbs :elements="[{ text: 'Venues', to: parentRoute }, { text: 'New venue' }]" />

    <Form
      :form-id="formId"
      :initial-values="Venue.getNew()"
    >
      <VenueFields />

      <FormActionButtons
        :show-save="isFormDirty()"
        :show-cancel="isFormDirty()"
        @save="handleSave"
        @cancel="onCancel"
      />
    </Form>
  </div>
</template>

<script setup lang="ts">
import VenueFields from './VenueFields.vue';
import { Form, useFormsStoreComposable } from 'vuniform';
import { useVenueStore } from '@/stores/venue';
import type { SaveVenueMutationInput, VenueAttributes } from '@/generated/graphql';
import * as Venue from '@/types/Venue';
import { useRouter } from 'vue-router';
import { useToast } from 'vue-toastification';
import FormActionButtons from '@/components/form/FormActionButtons.vue';
import VPBreadcrumbs from '@/components/VPBreadcrumbs.vue';

const venueStore = useVenueStore();
const router = useRouter();
const toast = useToast();
const { formId, formsStore, formGetValues, isFormDirty } = useFormsStoreComposable('new-venue-form');

const parentRoute = { name: 'VenueIndex' };

const handleSave = async () => {
  const values = formGetValues<VenueAttributes>();
  delete (values as { logo: any })['logo'];
  const payload: SaveVenueMutationInput = {
    clientMutationId: formId,
    venue: values,
  };
  const { result: newVenue, errors } = await venueStore.saveVenue(payload);
  if (errors) {
    formsStore.SET_ERRORS({ requesterId: formId, errors });
    return;
  }

  if (!newVenue) {
    return;
  }
  toast.success(`Venue '${newVenue.name}' added successfully!`);
  router.push(parentRoute);
};

const onCancel = () => formsStore.RESET_FIELD_VALUES(formId);
</script>
